import React from "react";
import GoogleDocsViewer from "react-google-docs-viewer";

export default function PDFViewer({ pdf, height = "400px" }) {
  return <GoogleDocsViewer width="100%" height={height} fileUrl={pdf} />;
}
